import { pubsub } from '@services';

class StickyAddToCart extends HTMLElement {
  /** @type {() => void} */ #unsubscribe;
  /** @type {IntersectionObserver | undefined} */ #observer;
  /** @type {HTMLElement | null} */ #productForm = document.querySelector(
    `product-form[data-product-id="${this.dataset.productId}"]`
  );
  #productId = this.dataset.productId;

  connectedCallback() {
    this.#init();

    this.#unsubscribe = pubsub.subscribe('variant:change', ({ id, data: { html } }) => {
      if (id !== this.dataset.productId) return;
      this.#handleVariantChange(html);
      this.#init();
    });
  }

  disconnectedCallback() {
    this.#unsubscribe();
  }

  /**
   * Initialize sticky bar state and product form observation.
   * @returns {void}
   */
  #init() {
    this.#setButtonState();
    this.#observeProductForm();
  }

  /**
   * Replace sticky bar content with the variant-specific HTML.
   * @param {DocumentFragment | HTMLElement} html - Fragment or element containing the updated sticky-add-to-cart markup.
   * @returns {void}
   */
  #handleVariantChange(html) {
    const stickyAddToCart = html.querySelector('sticky-add-to-cart');
    this.innerHTML = stickyAddToCart.innerHTML;
  }

  /**
   * Observe the main product form visibility and toggle sticky bar aria-hidden.
   * @returns {void}
   */
  #observeProductForm() {
    this.#observer?.unobserve(this.#productForm);

    if (!this.#observer) {
      this.#observer = new IntersectionObserver(([{ isIntersecting }]) => {
        this.setAttribute('aria-hidden', isIntersecting);
      });
    }

    // Timeout to ensure product-form has been cloned in product-form.js
    setTimeout(() => {
      this.#productForm = document.querySelector(
        `product-form[data-product-id="${this.#productId}"]`
      );
      if (!this.#productForm) return;
      this.#observer.observe(this.#productForm);
    }, 50);
  }

  /**
   * Sync disabled state of the sticky bar button with the main product form submit button.
   * @returns {void}
   */
  #setButtonState() {
    const button = this.querySelector('button');
    const formId = button?.getAttribute('form') || '';
    const productFormButton = this.#productForm?.querySelector(
      `form[id="${formId}"] button[type="submit"]`
    );

    button.disabled = productFormButton?.disabled || !productFormButton;
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
